module.exports = __webpack_public_path__ + "img/gift-05-c1.77b97aaa.png";